"use client";

import React from "react";

interface CitationSectionProps {
  standardCode?: string;
  sourceName: string;
  sourceUrl: string;
  paragraphs: React.ReactNode[];
  keyRequirements: string[];
}

export default function CitationSection({
  standardCode,
  sourceName,
  sourceUrl,
  paragraphs,
  keyRequirements,
}: CitationSectionProps) {
  return (
    <div className="citation grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
      {/* Left Column: Text Content */}
      <div className="lg:col-span-8 space-y-6">
        <div className="citation-head">
          <span className="sect">§</span>
          <h3>Regulatory Building Standards{standardCode ? ` — ${standardCode}` : ""}</h3>
          <span className="ref">Cited Standard</span>
        </div>
        <div className="space-y-4 text-sm leading-relaxed text-[var(--ink-soft)]">
          {paragraphs.map((p, idx) => (
            <div key={idx} className="font-sans leading-relaxed text-[14.5px] text-[var(--ink-soft)]">
              {p}
            </div>
          ))}
        </div>
        <div className="citation-source">
          <span>Source: {sourceName}</span>
          <a href={sourceUrl} target="_blank" rel="noopener noreferrer">
            View full standard &rarr;
          </a>
        </div>
      </div>

      {/* Right Column: Key Requirements Sidebar */}
      <div className="lg:col-span-4 border-t border-[var(--line)] pt-6 mt-2 lg:border-t-0 lg:border-l lg:pl-8 lg:pt-1 lg:mt-0 space-y-4 font-sans">
        <ul className="space-y-3 text-[13px] text-[var(--ink-soft)] leading-relaxed font-medium">
          {keyRequirements.map((item, idx) => (
            <li key={idx} className="flex gap-2.5 items-start">
              <span className="text-[var(--ink-faint)] font-bold text-sm leading-none select-none">
                •
              </span>
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
